// Header sticky behavior with collapsed mode option
(function() {
  const headerSection = document.querySelector("#shopify-section-header");
  if (!headerSection) return;
  
  // Check if collapsed mode is enabled by looking at the actual DOM state
  const navBar = document.querySelector('.nav-bar');
  const header = document.querySelector('.header');
  const keepCollapsed = navBar && window.getComputedStyle(navBar).display !== 'none' && 
                       header && window.getComputedStyle(header).display === 'none';
  
  function updateHeaderState() {
    if (keepCollapsed) {
      // In collapsed mode, remove sticky class from header section since nav-bar handles it
      headerSection.classList.remove("sticky");
    } else {
      // Normal behavior: sticky when scrolled
      if (window.pageYOffset > 0) {
        headerSection.classList.add("sticky");
      } else {
        headerSection.classList.remove("sticky");
      }
    }
  }
  
  // Initial state
  updateHeaderState();
  
  // Update on scroll (but only if not in collapsed mode)
  if (!keepCollapsed) {
    window.onscroll = updateHeaderState;
  }
})();

// Product Carousel initialization for multiple instances
(function() {
  function initializeCarousel(carouselSection) {
    if (!carouselSection || carouselSection.dataset.initialized === 'true') {
      return;
    }
    
    carouselSection.dataset.initialized = 'true';
    
    const track = carouselSection.querySelector('[data-carousel-track]');
    const prevBtn = carouselSection.querySelector('.product-carousel-nav--prev');
    const nextBtn = carouselSection.querySelector('.product-carousel-nav--next');
    const items = carouselSection.querySelectorAll('.product-carousel-item');
    
    if (!track || !items.length) {
      return;
    }

    let currentIndex = 0;

    function getItemsPerView() {
      return window.innerWidth <= 768 ? 1 : window.innerWidth <= 1024 ? 3 : 4;
    }

    function getMaxIndex() {
      const itemsPerView = getItemsPerView();
      return Math.max(0, items.length - itemsPerView);
    }

    function updateCarousel() {
      const itemsPerView = getItemsPerView();
      const maxIndex = getMaxIndex();
      
      // Ensure currentIndex doesn't exceed maxIndex
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }
      
      const translateX = -currentIndex * (100 / itemsPerView);
      track.style.transform = `translateX(${translateX}%)`;
      
      // Update button states
      if (prevBtn) prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
      if (nextBtn) nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
    }

    function nextSlide() {
      const maxIndex = getMaxIndex();
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        nextSlide();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        prevSlide();
      });
    }

    // Touch/swipe support for mobile
    let startX = 0;
    let startY = 0;
    let isScrolling = false;

    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isScrolling = false;
    });

    track.addEventListener('touchmove', function(e) {
      if (!isScrolling) {
        const deltaX = Math.abs(e.touches[0].clientX - startX);
        const deltaY = Math.abs(e.touches[0].clientY - startY);
        isScrolling = deltaY > deltaX;
      }
    });

    track.addEventListener('touchend', function(e) {
      if (!isScrolling) {
        const endX = e.changedTouches[0].clientX;
        const deltaX = startX - endX;
        
        if (Math.abs(deltaX) > 50) { // Minimum swipe distance
          if (deltaX > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
      updateCarousel();
    });

    // Initialize with a small delay to ensure everything is loaded
    setTimeout(function() {
      updateCarousel();
    }, 100);
  }

  // Initialize all carousels when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const carouselSections = document.querySelectorAll('.product-carousel-section');
    carouselSections.forEach(initializeCarousel);
  });
  
  // Also try to initialize after a longer delay in case of slow loading
  setTimeout(function() {
    const carouselSections = document.querySelectorAll('.product-carousel-section');
    carouselSections.forEach(initializeCarousel);
  }, 1000);
})();

// Mobile navigation toggle
document.querySelector(".header__mobile-nav-toggle").addEventListener("click",function(e){document.querySelector("html").classList.add("mm-open")}),document.querySelector(".close_btn").addEventListener("click",function(e){document.querySelector("html").classList.remove("mm-open")}),document.querySelector(".mobile-bg").addEventListener("click",function(e){document.querySelector("html").classList.remove("mm-open")}),document.querySelector(".acc-icon button").addEventListener("click",function(e){document.querySelector(".accessibly-otm-widget-button").click()});
//# sourceMappingURL=/s/files/1/0689/5268/6891/t/3/assets/custom.js.map?v=1671097215
